import { REGION_AU, REGION_US } from 'global/constants';

export type Regions = typeof REGION_AU | typeof REGION_US;

export const REGION_OPTIONS = [
  {
    label: 'Australia',
    value: REGION_AU,
  },
  { label: 'United States', value: REGION_US },
];
